import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { CasesService } from "../../cases.service";
import { fuseAnimations } from "@fuse/animations";
import { LabCase } from "../../case";
import { ActivatedRoute, Router } from "@angular/router";
import { StorageService } from "app/main/module/common/service/storage.service";
import * as moment from "moment";
import { is } from "date-fns/locale";
import { TranslateService } from "@ngx-translate/core";

const timeZone = require("moment-timezone");

@Component({
    selector: "app-case-detail",
    templateUrl: "./case-detail.component.html",
    styleUrls: ["./case-detail.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class CaseDetailComponent implements OnInit {
    titleMatIcon = this.getTitleMatIcon();
    page: number;
    perPage: number;
    case: LabCase[] = [];
    isLoading: Boolean = false;
    hasFirstDataShown: Boolean = false;
    searchText: any;
    status: string;

    constructor(
        public caseService: CasesService,
        private route: ActivatedRoute,
        private userService: StorageService,
        private router: Router,
        public translate: TranslateService
    ) {}

    ngOnInit(): void {
        const caseId = this.route.snapshot.queryParamMap.get("case_id");
        this.getSingleCase(caseId);
    }

    getTitleMatIcon(): string {
        return "assignment";
    }

    getSingleCase(id) {
        this.isLoading = true;
        this.caseService.getSingleCase(id).subscribe(
            (response: any) => {
                if (response && response.data) {
                    this.case = response.data;
                    this.hasFirstDataShown = true;
                    this.isLoading = false;
                    this.status = this.translateSentence(
                        `LabCases.${this.case[0].status}`
                    );
                    // console.log("Fetched cases:", this.case);
                } else {
                    this.case = [];
                }
            },
            (error) => {
                console.error("Error fetching cases:", error);
            }
        );
    }

    updateDate(value: string): string {
        if (!value || value.trim() === "") return "-";

        const tz = moment.tz.zone(this.userService.getCookie("defaultTz"))
            ? this.userService.getCookie("defaultTz")
            : "UTC";

        let m = moment(value);
        if (!m.isValid() && /^\d+$/.test(value)) {
            m = moment(Number(value));
        }

        return m.isValid() ? m.tz(tz).format("DD-MM-YYYY") : "-";
    }

    updateDateTime(value: string): string {
        if (!value || value.trim() === "") return "-";

        const tz = moment.tz.zone(this.userService.getCookie("defaultTz"))
            ? this.userService.getCookie("defaultTz")
            : "UTC";

        let m = moment(value);
        if (!m.isValid() && /^\d+$/.test(value)) {
            m = moment(Number(value));
        }

        return m.isValid() ? m.tz(tz).format("DD-MM-YYYY | hh:mm") : "-";
    }

    back() {
        this.router.navigate(["/cases/cases-list"]);
    }

    toUpperCaseString(str: string): string {
        if (!str) return "";
        return str.trim().charAt(0).toUpperCase() + str.trim().slice(1);
    }

    getColourByStatus(status: string): string {
        switch (status) {
            case "assigned":
                return "#FF8C00";
            case "received":
                return "#008000";
            default:
                return "#A9A9A9";
        }
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }
}
